module.exports = __webpack_public_path__ + "static/media/Email2.63c2231b.svg";